module.exports = __webpack_public_path__ + "img/pc-kf.23c5edb2.png";